import React from "react";
import {
  CollectionSliderDestinationFragment,
  CollectionSliderExclusiveOfferPerPromoFragment,
  CollectionSliderShipFragment,
  PageBuilderCollectionSliderFragment
} from "types/graphql-types";
import PageBuilderSectionTitle from "./PageBuilderSectionTitle";
import { BackgroundColor } from "types/componentBackground";
import { graphql } from "gatsby";
import { cardColorForBackground } from "./pageBuilderRenderHelper";
import { FilterByType } from "components/CollectionSlider/utils";

const DestinationsSlider = React.lazy(
  () => import("../CollectionSlider/DestinationsSlider")
);
const ShipsSlider = React.lazy(() => import("../CollectionSlider/ShipsSlider"));
const PromosSlider = React.lazy(
  () => import("../CollectionSlider/PromosSlider")
);

interface PageBuilderCollectionSliderProps
  extends PageBuilderCollectionSliderFragment {
  backgroundColor: BackgroundColor;
  collectionData: PageBuilderCollectionSliderFragment["collectionData"];
}

const PageBuilderCollectionSlider: React.FC<
  React.PropsWithChildren<PageBuilderCollectionSliderProps>
> = ({
  heading,
  collection,
  backgroundColor,
  filterByType,
  collectionData
}) => {
  const cardBackgroundColor = cardColorForBackground(backgroundColor);
  return (
    <React.Fragment>
      <PageBuilderSectionTitle {...heading} />
      <React.Suspense fallback={<div></div>}>
        {collection == "destinations" && (
          <DestinationsSlider
            cardBackgroundColor={cardBackgroundColor}
            filterByType={filterByType as FilterByType}
            data={collectionData as CollectionSliderDestinationFragment[]}
          />
        )}
        {collection == "ships" && (
          <ShipsSlider
            cardBackgroundColor={cardBackgroundColor}
            filterByType={filterByType as FilterByType}
            data={collectionData as CollectionSliderShipFragment[]}
          />
        )}
        {collection == "offers" && (
          <PromosSlider
            cardBackgroundColor={cardBackgroundColor}
            offersVisibility="hideOffersCollection"
            data={
              collectionData as CollectionSliderExclusiveOfferPerPromoFragment[]
            }
          />
        )}
      </React.Suspense>
    </React.Fragment>
  );
};

export default PageBuilderCollectionSlider;

export const fragments = graphql`
  fragment CollectionSliderDestination on SanityDestination {
    _id
    id
    isExpeditionDestination
    card {
      ...AsCard
    }
    fullPath
    metadata {
      tracking {
        name
      }
    }
  }

  fragment CollectionSliderShip on SanityShip {
    _id
    id
    shipType
    fullPath
    metadata {
      tracking {
        name
      }
    }
    card {
      ...AsCard
    }
  }

  fragment CollectionSliderExclusiveOfferPerPromo on SanityExclusiveOfferPerPromo {
    ...OfferContent
    hideInCollections
  }

  fragment PageBuilderCollectionSlider on SanityCollectionSlider {
    _key
    sectionLayoutConfig {
      ...SectionLayoutConfig
    }
    heading {
      ...SectionTitle
      ...SectionTitleCTAs
    }
    collection
    filterByType
    collectionData {
      ... on SanityShip {
        ...CollectionSliderShip
      }

      ... on SanityDestination {
        ...CollectionSliderDestination
      }

      ... on SanityExclusiveOfferPerPromo {
        ...CollectionSliderExclusiveOfferPerPromo
      }
    }
  }
`;
